import React, { useEffect, useState } from "react";
import Header from "./Header";
import Loader from "./Loader";
import Footer from "./Footer";

const Actualites = () => {
  const handleClick = (event) => {
    event.preventDefault(); // Prevent the default action
    console.log("Link click prevented!");
  };
  // State to control visibility
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        <section
          className="page-title bg-overlay-black-60 parallax"
          style={{
            backgroundImage:
              "url(/assets/images/actualité/slider-actualite.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name">
                  <h1>ACTUALITÉS</h1>
                  <p>Quoi De Neuf Chez SACEM ?</p>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> Accueil
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>Actualités</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/*=================================
page-title */}
        {/*=================================
 Grid-1 */}
        <div className="page-section-ptb">
          <section className="page-section-pb white-bg">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="section-title text-center">
                    <h6>ACTUALITÉS</h6>
                    <h2 className="title-effect"> SACEM GROUP</h2>
                  </div>
                </div>
              </div>
               {/** row 1 */}
              <div className="row">
                {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                           <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/mission economique roumaine en Tunisie/mission_economique_roumaine_Tunisie1.jpg"
                            alt="délégation économique roumaine"
                            //style={{ maxHeight: "309px" }}
                          />
                       
                        </div>
                        <div className="item">
                           <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/mission economique roumaine en Tunisie/mission_economique_roumaine_Tunisie2.jpg"
                            alt="délégation économique roumaine"
                            //style={{ maxHeight: "309px" }}
                          />
                       
                        </div>
                        <div className="item">
                           <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/mission economique roumaine en Tunisie/mission_economique_roumaine_Tunisie3.jpg"
                            alt="délégation économique roumaine"
                            //style={{ maxHeight: "309px" }}
                          />
                       
                        </div>
                        <div className="item">
                           <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/mission economique roumaine en Tunisie/mission_economique_roumaine_Tunisie4.jpg"
                            alt="délégation économique roumaine"
                            //style={{ maxHeight: "309px" }}
                          />
                       
                        </div>
                        <div className="item">
                           <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/mission economique roumaine en Tunisie/mission_economique_roumaine_Tunisie5.jpg"
                            alt="délégation économique roumaine"
                            //style={{ maxHeight: "309px" }}
                          />
                       
                        </div>
                        
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "796px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Accueil d'une délégation économique roumaine de haut niveau sur le site de Menzel Bourguiba.
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" />28 avril 2026
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          À l’occasion de la mission économique roumaine en Tunisie, organisée dans le cadre du renforcement des relations économiques entre les deux pays, Sacem Industries صـــاســام للصنــاعات a eu l’honneur d’accueillir, le 28 avril 2026, une délégation économique roumaine de haut niveau sur son site de Menzel Bourguiba.
                        </p>
                        <p>Cette visite, initiée et organisée par Conect Bizerte, a constitué une opportunité privilégiée pour présenter notre savoir-faire dans la fabrication de transformateurs électriques, ainsi que notre organisation industrielle, nos processus de certification et notre présence active sur les marchés internationaux, notamment en Afrique et dans le monde arabe.</p>
                        <p>Les échanges ont été riches et constructifs, ouvrant des perspectives concrètes de coopération et de partenariat avec des acteurs économiques roumains.</p>
                        <p>Sacem Industries صـــاســام للصنــاعات réaffirme, à travers cette rencontre, son engagement à contribuer activement au développement de partenariats internationaux durables et à promouvoir l’expertise industrielle tunisienne.</p>
                        <p>#sacem #industrie #Tunisie #Roumanie #cooperation #partenariat #business #export #innovation #conectbizerte</p>
                        
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/7_eme_edition_Salon_Emploi_Universite_Centrale/7_eme_edition_Salon_Emploi_Universite_Centrale1.jpg"
                            alt="7ᵉ édition du Salon de l’Emploi de l’Université Centrale"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/7_eme_edition_Salon_Emploi_Universite_Centrale/7_eme_edition_Salon_Emploi_Universite_Centrale2.jpg"
                            alt="7ᵉ édition du Salon de l’Emploi de l’Université Centrale"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/7_eme_edition_Salon_Emploi_Universite_Centrale/7_eme_edition_Salon_Emploi_Universite_Centrale3.jpg"
                            alt="7ᵉ édition du Salon de l’Emploi de l’Université Centrale"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "796px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                           Participation à la 7ᵉ édition du Salon de l’Emploi de l’Université Centrale
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 29 avril 2026 
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                         Retour sur notre participation au Salon de l’Emploi Sacem Industries صـــاســام للصنــاعات  a eu le plaisir de participer à la 7ᵉ édition du Salon de l’Emploi de l’Université Centrale, tenue le 29 avril 2026 à l’UTICA.
                        </p>
                        <p>
                          Cet événement a été une excellente opportunité d’échanges avec les étudiants et jeunes talents, ainsi qu’un moment fort de partage entre le monde académique et professionnel.
                        </p>
                       
                        <p>
                          Nous tenons à adresser nos sincères remerciements à notre équipe RH pour son engagement et sa contribution à la réussite de cette participation.
                        </p>
                        <p>
                          Un remerciement particulier à Mr Amine Taamallah et Mme Hanen Netta pour leur participation remarquable et leur professionnalisme.
                        </p>
                       
                        <p>
                          #sacem #RH #talent #recrutement #partenariat #fierté
                        </p>
                      
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/** row 2 */}
            <div className="row">
              {/** actu 1 */}
             <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/IT/IT1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "655px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Meilleure Équipe de l’année 2025
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 30 Avril 2026
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Sacem Industries صـــاســام للصنــاعات est fière de mettre à l’honneur son département IT, désigné Meilleure Équipe de l’année 2025.
                        </p>
                        <p>
                          Cette reconnaissance interne vient couronner une autre distinction prestigieuse, avec l’obtention du trophée "Outstanding Internship Provider in IT" lors de la 7ᵉ édition du Salon de l’Emploi de l’Université Centrale, tenue le 29 avril 2026.
                        </p>
                        <p>
                          Ces succès témoignent de l’engagement, du professionnalisme et de l’excellence dont fait preuve notre équipe IT au quotidien, tant dans ses performances que dans son rôle clé dans l’accompagnement des jeunes talents.
                        </p>
                        <p>Un grand bravo à :</p>
                        <ul>
                          <li>Mr Elyes Trabelsi</li>
                          <li>Mr Mouheb Bejaoui</li>
                          <li>Mr Amine Sradkia</li>
                          <li>Mr Saber Mhadhbi</li>
                        
                        </ul>
                        <p>
                          #fierté #excellence #TeamIT #sacem #talent #leadership
                        </p>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                       
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          
                        <video
                        width="100%"
                        controls
                       // autoPlay
                        muted
                        loop
                        >
                        <source src="/assets/images/Lotfi_hammemi.mp4" type="video/mp4" />
                        </video>
                        </div>
                        
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "655px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Un moment émouvant et chargé d’émotion au sein du Groupe SACEM
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" />27 Janvier 2026
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          À l’occasion de l’anniversaire de Monsieur Lotfi Hammami et de son départ à la retraite, sa fille, Mademoiselle Khaoula, également membre de la famille SACEM, lui a préparé une belle surprise exprimant des sentiments sincères de reconnaissance, d’affection et de gratitude.
                        </p>
                        <p>Nos plus sincères félicitations et notre profonde reconnaissance sont adressées à Monsieur Lotfi Hammami.</p>
                        <p>Monsieur Khaled Kamoun, Directeur Général du Groupe, lui adresse également ses chaleureux remerciements pour ses années de dévouement, d’engagement et pour sa contribution précieuse au parcours et au développement de l’entreprise.</p>
                    
                        <p>#صاسام #تقدير #روح_الفريق #قيم_المؤسسة #الصناعة_التونسية 
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformer #Tunisia
                          #Africa
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                
                
              {/** row 3 */}
              <div className="row">
              {/** actu 1 */}
              <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST4.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sante_tenja/ST5.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "1160px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Centre de santé de base de Tinga, dans le gouvernorat
                          de Bizerte
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              SACEM Industries News{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Decembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          La société Sacem Industries a choisi de terminer
                          l'année 2025 par une action humanitaire visant à
                          soutenir les établissements de santé locaux. Dans le
                          cadre de sa responsabilité sociale, et sur proposition
                          de Mme Yousra Abbas, membre du Conseil régional de
                          Bizerte, et sous la supervision de M. Adnan Ben Bakri,
                          directeur de l'hôpital régional de Manzel Bourguiba,
                          la société a réaménagé et rénové le centre de santé de
                          base de Tinja, dans le gouvernorat de Bizerte.
                        </p>
                        <p>
                          🛠️ Les interventions de Sacem Industries ont porté sur
                          :
                        </p>
                        <ul>
                          <li>
                            La restauration des murs et la remise en peinture.
                          </li>
                          <li>La réparation des portes et des serrures.</li>
                          <li>
                            La rénovation des couloirs extérieurs et le
                            remplacement de l'auvent de protection.
                          </li>
                          <li>
                            L'amélioration de l'entrée principale et le
                            balisage des couloirs pour un meilleur accueil des
                            citoyens.
                          </li>
                        </ul>
                        <p>
                          Cette initiative vient renforcer notre engagement
                          envers notre environnement social et soutenir les
                          structures de santé publiques au profit des habitants
                          de Ténja.
                        </p>
                        <p>
                          🙏 M. Khaled Kamoun adresse ses sincères remerciements
                          à l'équipe de SASAM Industries:
                        </p>
                        <ul>
                          <li>M. Mehdi Ben Hadada</li>
                          <li>M. Louati Traïa</li>
                          <li>M. Ahmed Ben Ammar</li>
                          <li>M. Kamal Deridi</li>
                          <li>M. Khaled Ben Zitoune</li>
                          <li>M. Noureddine Ben Mohamed</li>
                          <li>M. Mahmoud Tunisi</li>
                          <li>M. Aymen El Gharbi</li>
                        </ul>
                        <p>
                          Vos efforts sont appréciés et respectés, et vous avez
                          eu un impact considérable sur la communauté grâce à un
                          simple geste.
                        </p>
                        <p>
                          🤝 Ensemble pour un impact positif réel et durable sur
                          notre communauté.
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformer #Tunisia
                          #Africa
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/UC1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/UC2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "1160px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Forum des Stages PFE 2026 organisé par l'École
                          Centrale Polytech / IT - Groupe Université Centrale
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 26 Novembre
                              2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Notre merveilleuse équipe a présenté plusieurs sujets
                          de Projets de Fin d'Études (PFE) aux étudiants, dans
                          le but de renforcer le lien entre le monde académique
                          et professionnel, et d'offrir aux futurs diplômés des
                          opportunités concrètes d'apprentissage et
                          d'innovation.
                        </p>
                        <p>
                          Merci au Groupe Université Centrale pour l'accueil
                          chaleureux et l'organisation irréprochable. Nous
                          sommes ravis de contribuer à la formation des leaders
                          de demain.
                        </p>
                        <p>
                          Merci également à notre merveilleuse équipe : Mr Elyes
                          Trabelsi et Mr Saber Mhadhbi.
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformateur #Tunisie
                          #Afrique
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
              {/** row 4 */}
              <div className="row">
                      
                {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Stages PFE 2026/ENIB3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "620px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Journée des Entreprises organisée par l'École
                          Nationale d'Ingénieurs de Bizerte (ENIB)
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 26 Novembre
                              2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Notre merveilleuse équipe a présenté plusieurs sujets
                          de Projets de Fin d'Études (PFE) aux élèves
                          ingénieurs, dans le but de renforcer le lien entre le
                          monde académique et l'industrie, et d'offrir aux
                          futurs diplômés des opportunités concrètes
                          d'apprentissage et d'innovation.
                        </p>
                        <p>
                          Merci à l'ENIB pour l'accueil chaleureux et
                          l'organisation irréprochable. Nous sommes ravis de
                          contribuer à la formation des leaders de demain.
                        </p>
                        <p>
                          Merci également à notre merveilleuse équipe : Amine
                          Taamallah, Amine Sradkia, Mohamed Lamine Hassine,
                          Aymen Rezgui et Ayoub Marzouki.
                        </p>
                        <p>
                          #PowerTransformer #EnergyInfrastructure
                          #IndustrialTechnology #SACEM #Transformateur #Tunisie
                          #Afrique #ENIB #PFE #Partenariat #Ingénierie
                          #Industries #Talents
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire1/ep4.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "620px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Engagement social SACEM GROUP - école primaire du
                          quartier Hay Al-Arish - Tinga
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Septembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Dans le cadre de son engagement social, SACEM
                          INDUSTRIES a installé une nouvelle porte et entretenu
                          une autre porte à l'école primaire du quartier Hay
                          Al-Arish - Tinga, contribuant ainsi à améliorer les
                          conditions scolaires et à offrir un environnement plus
                          sûr à nos enfants.
                        </p>
                        <p>
                          M. Khaled Kammoun, directeur général de SACEM GROUP,
                          souhaite également bonne chance et réussite à nos
                          élèves de tous niveaux et adresse ses sincères
                          remerciements et sa gratitude à nos employés qui ont
                          contribué par leurs efforts à la réussite de cette
                          initiative.
                        </p>
                        <p>Ensemble, nous avons un impact positif ✨.</p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
               
                
               
                
              </div>

              {/** row 5 */}
              <div className="row">
              {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep1.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep2.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep3.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ecole primaire2/ep4.jpg"
                            alt="Engagement social SACEM INDUSTRIES"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "670px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Engagement social SACEM GROUP - école primaire du
                          quartier Hay Al Najah Zaghaba
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Septembre 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Dans le cadre de son engagement social, et à la
                          demande de M. Ziad Harzallah, maire de Manzel
                          Bourguiba, et de M. Marwan Chalghoumi, membre du
                          conseil municipal, SACEM GROUP a réalisé des travaux
                          de rénovation dans l'école primaire du quartier Hay Al
                          Najah Zaghaba, notamment la construction et la remise
                          en état d'une partie du réseau électrique et
                          l'entretien de l'éclairage, afin de contribuer à la
                          création d'un meilleur environnement scolaire pour nos
                          enfants du quartier Al Najah.
                        </p>
                        <p>
                          M. Khaled Kammoun, directeur général de SACEM GROUP,
                          adresse ses sincères remerciements et sa gratitude à
                          nos employés qui ont participé à la réussite de cette
                          noble initiative.
                        </p>
                        <p>
                          💡🌟 Ensemble, nous avons un impact positif. 🤝 💪
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
               
               {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/25MVA/25MVA.jpg"
                            alt="SACEM TRANSFORMATEUR 25 MVA TUNISIE"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "670px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Nouvelle Réalisation : Transformateur de Puissance 25
                          MVA avec notre partenaire IFRIQIYA DU COMMERCE
                          INTERNATIONAL (ICI) pour le compte de la Société
                          Énergie Électrique du Congo (E2C)
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> Juin 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM Industries renforce une fois de plus sa position
                          de leader régional dans la fabrication de
                          transformateurs de puissance en collaboration avec
                          notre partenaire IFRIQIYA DU COMMERCE INTERNATIONAL
                          (ICI). Nous sommes fiers d’annoncer la livraison
                          récente d’un transformateur de puissance triphasé 25
                          MVA (30/20 kV – Dyn11 – ONAN), la Société Énergie
                          Électrique du Congo (E2C).
                        </p>
                        <p>
                          Cette réalisation témoigne de notre capacité à
                          répondre aux exigences techniques les plus élevées,
                          tout en respectant les normes internationales de
                          qualité et de performance.
                        </p>
                        <p>
                          Ce projet illustre notre engagement continu à
                          accompagner les opérateurs énergétiques africains dans
                          le développement durable de notre continent.
                        </p>
                        <p>
                          👏 Félicitations à nos équipes pour leur
                          professionnalisme et leur engagement dans la réussite
                          de ce projet.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
                
                
              </div>
              {/** row 6 */}
              <div className="row">
              {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib1.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib2.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib3.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/agreement enib/enib4.jpg"
                            alt="collaboration agreement_SACEM_ENIB"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          la signature d'un accord de collaboration.
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 02 Juin 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Aujourd'hui, nous avons eu le plaisir d'accueillir une
                          délégation de l'#ENIB (Ecole Nationale d'Ingénieurs de
                          Bizerte), conduite par M. Hakim Hammami, Directeur de
                          l'#ENIB, pour une visite du site et la signature d'un
                          accord de collaboration.
                        </p>
                        <p>
                          Ce partenariat marque une étape importante dans le
                          renforcement des liens entre le monde universitaire et
                          l'industrie. Il offrira de nouvelles possibilités de
                          stages, de projets de fin d'études et d'initiatives
                          conjointes en matière d'innovation.
                        </p>
                        <p>
                          🤝 Un grand merci à #ENIB pour sa confiance et son
                          engagement. Ensemble, nous façonnons l'avenir de
                          l'industrie et de la formation des ingénieurs !
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_5.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_1.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_2.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            //style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_3.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Social Progress Award for 2024_SACEM_TRANSFORMATEUR_4.jpg"
                            alt="Social Progress Award for 2024 SACEM TRANSFORMATEUR"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "500px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Prix du progrès social 2024
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité SACEM Industries{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 01 Mai 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          À l'occasion de la Journée mondiale du travail, le 1er
                          mai 2025, SACEM Industries s'est vu décerner par le
                          ministre des Affaires sociales le Prix du progrès
                          social 2024. Cette distinction est l'aboutissement
                          d'années de dévouement à la responsabilité sociale des
                          entreprises en collaboration avec nos partenaires
                          sociaux, la société civile et les autorités locales.
                        </p>
                        <p>
                          A cette occasion, le directeur général de SACEM
                          Industries, M. Khaled Kamoun, félicite tous les
                          employés, hommes et femmes. Il adresse également ses
                          sincères remerciements aux membres du syndicat
                          principal et du comité consultatif, qui ont été les
                          meilleurs partenaires dans l'obtention de ce prix, qui
                          servira d'incitation à prendre davantage soin des
                          travailleurs et à améliorer les conditions de travail.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
               
                
                
                
              </div>
              {/** row 7*/}
              <div className="row">
              {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme1.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme2.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme3.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme4.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme5.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme6.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme7.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/exercice secourisme/secourisme8.jpg"
                            alt="Exercice de Nuit chez SACEM Industries"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "600px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Exercice de Nuit chez SACEM Industries 🚒🧯
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 24 Avril 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM GROUP مجمع صـــاســام <br />
                          Le 24 Avril 2025, SACEM Industries a mené un exercice
                          de nuit de secourisme et d'intervention contre les
                          incendies à notre usine des transformateurs
                          électriques à Menzel Bourguiba. Nos équipes ont
                          démontré leur engagement et leur expertise en matière
                          de sécurité et de gestion des urgences. Un grand merci
                          à tous les participants pour leur dévouement et leur
                          professionnalisme. Un remerciement spécial à l'équipe
                          de sûreté, nos collègues de la section CIRCUIT
                          MAGNETIQUE et à MOHAMED ALI MABROUK pour leur
                          engagement remarquable.
                        </p>
                        <p>
                          Ensemble, nous assurons un environnement de travail
                          plus sûr pour tous. 💪🔥
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
              {/** actu 2 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib3.jpg"
                            alt="SACEM sponsor enib"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib1.jpg"
                            alt="SACEM sponsor enib"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib2.jpg"
                            alt="SACEM sponsor enib"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Enib/enib4.jpg"
                            alt="SACEM sponsor enib"
                            //  style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "600px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Participation en tant que sponsor au séminaire sous le
                          thème "Géopolitique, Intelligence Artificielle et
                          Grandes Tendances Mondiales" (ISG Bizerte).
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 23 Avril 2025
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM Industries a eu l'honneur de participer en tant
                          que sponsor au séminaire qui s'est tenu le 23 avril
                          2025 à l'Institut Supérieur d'Administration des
                          Entreprises de Bizerte (ISG Bizerte), sous la
                          direction de M. Nizar Yaiche, et sous le thème :
                          "Géopolitique, Intelligence Artificielle et Grandes
                          Tendances Mondiales".
                        </p>
                        <p>
                          Cet événement a été organisé par l'Ecole Nationale
                          d'Ingénieurs de Bizerte (ENIB), l'Institut Supérieur
                          d'Administration des Entreprises de Bizerte (ISG
                          Bizerte), l'Institut Préparatoire aux Etudes
                          d'Ingénieurs de Bizerte (IPEIB), et l'Université de
                          Carthage, ainsi que les clubs : AI Innovator ENIB, 4C
                          IPEIB, et 4C ISG Bizerte.
                        </p>
                        <p>
                          Nous remercions sincèrement les organisateurs pour
                          leur aimable invitation et leur excellente
                          organisation.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
                
              </div>
              {/** row 8*/}

              <div className="row">
              {/** actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/iso-sacem.jpg"
                            alt="Certification renouvelée avec succès SACEM Industries"
                            // style={{ maxHeight: "309px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "550px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a href="#" onClick={handleClick}>
                            Certification renouvelée avec succès !
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                Actualité SACEM Industries{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 18 Avril 2025
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            Nous sommes fiers d'annoncer que notre système de
                            management intégré (Qualité, Sécurité,
                            Environnement) a été audité avec succès, aboutissant
                            au renouvellement de nos certifications :
                          </p>
                          <p>✅ ISO 9001:2015 </p>
                          <p>✅ ISO 14001:2015</p>
                          <p>✅ ISO 45001:2018</p>
                          <p>
                            Cet audit a mis en lumière l'implication de nos
                            équipes et la solidité de notre organisation.{" "}
                          </p>
                          <p>
                            👏 Un grand merci à tous nos collaborateurs pour
                            leur sérieux, leur engagement et leur contribution à
                            cette réussite collective. Ensemble, nous continuons
                            à progresser et à viser l'excellence.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              {/** actu 2 */}

                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche01-01.jpg"
                            alt="Action blanche pour lutte contre incendie SACEM"
                            style={{ height: "555px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche02-02.jpg"
                            alt="Action blanche pour lutte contre incendie SACEM"
                            style={{ height: "555px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Op-blanche03-03.jpg"
                            alt="Action blanche pour lutte contre incendie SACEM"
                            style={{ height: "555px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "550px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Action blanche pour lutte contre incendie, évacuation
                          et secourisme.
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 02 Décembre
                              2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          SACEM GROUP مجمع صـــاســام <br />
                          Retour sur l'action blanche pour lutte contre
                          incendie, évacuation et secourisme. Remerciements à
                          toute l'équipe de la protection civile de menzel
                          Bourguiba et aux personnels de SACEM GROUP مجمع
                          صـــاســام pour le bon déroulement de l'action.{" "}
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
               
               
                
                         
              </div>
              {/** row 9*/}

              <div className="row">
              {/**actu 1*/}
                 <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ACT2.jpg"
                            alt="responsabilité sociale SACEM"
                            style={{ maxHeight: "381px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Réaménagement de la bibliothèque publique de Tinja
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 27 Septembre
                              2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Dans le cadre de la responsabilité sociale de
                          l'entreprise, et suivant les instructions de M. Khaled
                          Kammoun, Directeur Général du Groupe SACEM, des
                          interventions ont été effectuées pour réaliser des
                          travaux d'entretien et de réparation pour le
                          réaménagement de la bibliothèque publique de Tinja.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              {/**actu 2 */}

                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/sans-tabac.jpg"
                            alt="La journée mondiale sans tabac SACEM"
                            style={{ height: "381px" }}
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/san-tabac2.jpg"
                            alt="La journée mondiale sans tabac SACEM"
                            style={{ height: "381px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          La journée mondiale sans tabac
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 31 Mai 2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          A l'occasion de la journée mondiale sans tabac le 31
                          mai 2024, une journée de sensibilisation a été
                          organisée à l'usine Sassam Industries à Menzel
                          Bourguiba-Tinja au profit des ouvriers et employés sur
                          les effets néfastes du tabagisme et ses répercussions
                          négatives sur la santé, en collaboration avec la
                          direction régionale de la santé à Bizerte et le
                          complexe de la médecine du travail à Bizerte.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                       
                
                
                
              </div>
              {/** row 10*/}
              <div className="row">
              {/**actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/esprit1.jpg"
                            alt="ESPRIT SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/esprit.jpg"
                            alt="ESPRIT SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a href="#" onClick={handleClick}>
                            Accueil des étudiants d'ESPRIT
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                Actualité Usine{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 08 Mai 2024
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            Accueille des étudiants d'ESPRIT : École Supérieure
                            Privée d'Ingénierie et de Technologies dans notre
                            usine de Transformateurs. Nous avons eu
                            l'opportunité de leur présenter en détail le
                            processus de fabrication des différentes composantes
                            du transformateur électrique.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
              {/**actu 2 */}

                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque.jpg"
                            alt="pétanque SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque1.jpg"
                            alt="pétanque SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/Petanque2.jpg"
                            alt="pétanque SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div className="entry-title mb-10">
                        <a href="#" onClick={handleClick}>
                          Premier tournoi amical de pétanque
                        </a>
                      </div>
                      <div className="entry-meta mb-10">
                        <ul>
                          <li>
                            {" "}
                            <i className="fa fa-folder-open-o" />{" "}
                            <a href="#" onClick={handleClick}>
                              {" "}
                              Actualité Usine{" "}
                            </a>{" "}
                          </li>

                          <li>
                            <a href="#" onClick={handleClick}>
                              <i className="fa fa-calendar-o" /> 18 Février 2024
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="entry-content">
                        <p>
                          Le GROUPE SACEM tient à remercier tous les
                          participants du premier tournoi amical de pétanque du
                          18 février 2024 au complexe sportif de la SACEM. Il
                          félicite également les vainqueurs de l'association de
                          la fédération du domicile et de l'association des
                          jeunes de Tinja et leur souhaite plus d'éclat dans les
                          compétitions à venir.
                        </p>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>
              {/**row 11 */}
              <div className="row">
                {/**actu 1 */}
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className="blog-entry mb-50">
                    <div className="entry-image clearfix">
                      <div
                        className="owl-carousel bottom-center-dots"
                        data-nav-dots="ture"
                        data-items={1}
                        data-md-items={1}
                        data-sm-items={1}
                        data-xs-items={1}
                        data-xx-items={1}
                      >
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023.jpg"
                            alt="Energies Renouvelables SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023_3.jpg"
                            alt="Energies Renouvelables SACEM"
                          />
                        </div>
                        <div className="item">
                          <img
                            className="img-fluid"
                            src="/assets/images/actualité/home/ELEK_ENER_2023_2.jpg"
                            alt="Energies Renouvelables SACEM"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="blog-detail" style={{ minHeight: "348px" }}>
                      <div>
                        <div className="entry-title mb-10">
                          <a href="#" onClick={handleClick}>
                            Salon de l’Electricité et des Energies Renouvelables
                            ELEK ENER 2023
                          </a>
                        </div>
                        <div className="entry-meta mb-10">
                          <ul>
                            <li>
                              {" "}
                              <i className="fa fa-folder-open-o" />{" "}
                              <a href="#" onClick={handleClick}>
                                {" "}
                                Actualité Usine{" "}
                              </a>{" "}
                            </li>

                            <li>
                              <a href="#" onClick={handleClick}>
                                <i className="fa fa-calendar-o" /> 11 - 15
                                October 2023
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="entry-content">
                          <p>
                            Retour sur notre participation au 2ème Salon de
                            l'électricité et des énergies renouvelables ELEK
                            ENER 2023, qui s'est tenu du 11 au 15 octobre au
                            Parc des Expositions du Kram à Tunis, avec notre
                            partenaire Medelec Switchgear.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="entry-share clearfix"
                      style={{
                        marginTop: "0px",
                        paddingBottom: "1.25rem",
                        paddingRight: "1.25rem",
                        paddingTop: "0.5rem",
                      }}
                    >
                      <div className="social list-style-none float-right">
                        <strong>Nous suivre: </strong>
                        <ul>
                          <li>
                            <a href="https://www.facebook.com/sacemgroup/?locale=fr_FR">
                              {" "}
                              <i className="fa fa-facebook" />{" "}
                            </a>
                          </li>
                          <li>
                            <a href="https://fr.linkedin.com/company/sacem-group">
                              {" "}
                              <i className="fa ti-linkedin" />{" "}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Actualites;
